import { useCallback } from "react";
import type { StudioApiClient } from "../../../api.js";
import { usePolling } from "../../../usePolling.js";

export function useMissionControl(api: StudioApiClient, pollMs: number) {
  const loadMissionControl = useCallback(() => api.getMissionControlSummary(), [api]);
  const missionControlState = usePolling(loadMissionControl, pollMs);

  const loadScanOpportunityCount = useCallback(async () => {
    try {
      const list = await api.listPublicScanOpportunities();
      return list.opportunities.length;
    } catch {
      return 0;
    }
  }, [api]);
  const scanOpportunitiesState = usePolling(loadScanOpportunityCount, pollMs);

  return { missionControlState, scanOpportunitiesState };
}
